import React from "react"
import { graphql, Link } from "gatsby"
import parse from "html-react-parser"

import * as s from "./404.module.scss"

const PageNotFound = ({ data }) => {
  const { acf404Page } = data.wpPage

  return (
    <div
      className={s.pageNotFound}
      style={{
        backgroundImage: `url(${acf404Page.heroImage.sourceUrl})`,
        backgroundSize: "cover",
      }}
    >
      <div style={{ background: "rgba(0, 0, 0, 0.2" }}>
        <div className={s.pageNotFound__island}>
          <h1>{parse(acf404Page.headlineText)}</h1>

          <p className={s.pageNotFound__island___text}>{acf404Page.blurb}</p>

          <Link to="/" className={s.pageNotFound__island___button}>
            <span>Back Home</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound

export const query = graphql`
  query PageNotFoundQuery {
    wpPage(slug: { eq: "pagenotfound" }) {
      acf404Page {
        blurb
        headlineText
        heroImage {
          sourceUrl
        }
      }
    }
  }
`
